import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../apiSetup/apiCall";

export const submitUserData = createAsyncThunk(
  "submitUser/fetchSubmitUser",
  async ({stationId, payload}) => {
    try {
      const response = await api.post(`prometheus/${stationId}/user/add/`, payload);
      return response.data;
    } catch (error) {
      console.error("Error Submitting Data:", error);
      return error.response.data;
    }
  }
);

const SubmitUserSlice = createSlice({
  name: "submitUser",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitUserData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(submitUserData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(submitUserData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message; // Access the error message
      });
  },
});

export default SubmitUserSlice.reducer;
